




























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ProcessingAndManagedManagementData } from '@/modules/tickets/incidents/processing-and-managed-management/domain/processing-and-managed-management-data';

@Component({
    name: 'processing-and-managed-management-ticket-confirmation',
})
export default class ProcessingAndManagedManagementTicketConfirmation extends Vue {
    @Prop({ required: true })
    generalInformation!: ProcessingAndManagedManagementData;

    private isFormValid: boolean = true;

    private isCreatingTicket: boolean = false;

    sendRequirementTicket() {
        this.$emit('sendRequirementTicket');
    }

    previousStep() {
        this.$emit('previousStep');
    }

    reset() {
        this.$emit('reset');
    }
}
